var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedStage)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"candidates-list"},_vm._l((_vm.candidates),function(item,index){return _c('CandidateItem',{key:`${item.id}_${index}`,attrs:{"candidate":item}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }